import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "timetable-table" }
const _hoisted_2 = {
  key: 0,
  class: "timetable-table__spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "table"
}
const _hoisted_4 = { class: "table__row" }
const _hoisted_5 = { class: "table__head" }
const _hoisted_6 = { class: "table__head" }
const _hoisted_7 = { class: "table__head" }
const _hoisted_8 = { class: "table__head" }
const _hoisted_9 = { class: "table__head" }
const _hoisted_10 = ["data-date"]
const _hoisted_11 = { class: "table__cell" }
const _hoisted_12 = { class: "table__cell" }
const _hoisted_13 = { class: "table__cell" }
const _hoisted_14 = { class: "table__cell" }
const _hoisted_15 = { class: "table__cell" }
const _hoisted_16 = {
  key: 2,
  class: "no-departures"
}

import Spinner from "@/components/icons/base/Spinner.vue";
import { HHMM, YYYYMMDD } from "@/helpers/dateHelpers";
import { TimetableDeparture } from "@/models/front/Timetable/TimetableDeparture";

interface Props {
    departures?: TimetableDeparture[];
    isLoading: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimetableTable',
  props: {
    departures: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Spinner, { isLoading: true })
        ]))
      : (_ctx.departures?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`timetable.headers.route`)), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(`timetable.headers.departure`)), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(`timetable.headers.arrival`)), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`timetable.headers.journeyLength`)), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`timetable.headers.vessel`)), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departures, (departure, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "table__row",
                key: index,
                "data-date": _unref(YYYYMMDD)(departure.departureDateTime)
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(departure.routeName), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(HHMM)(new Date(departure.departureDateTime))), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(departure.arrivalDateTime ? _unref(HHMM)(new Date(departure.arrivalDateTime)) : ""), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(departure.journeyLength), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(departure.vessel), 1)
              ], 8, _hoisted_10))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t(`timetable.warnings.departures`)), 1)
          ]))
  ]))
}
}

})